import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Uuid} from "../interface/response/uuid";
import {first, take} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {PartnerTagsImport} from "../interface/partner-tags-import";

@Injectable({
  providedIn: 'root'
})
export class PartnerTagsImportService {
  public readonly importListSubject: ReplaySubject<CountedAndPaginated<PartnerTagsImport>>
    = new ReplaySubject<CountedAndPaginated<PartnerTagsImport>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public import(formData: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/partner-tags/method/import`, formData)
      .pipe(
        take(1)
      ) as Observable<Uuid>;
  }

  public getImport(importId: string): Observable<PartnerTagsImport> {
    return this.httpClient.get(`/rest/crm/partner-tags-import/${importId}`)
      .pipe(first()) as Observable<PartnerTagsImport>;
  }

  public loadImportList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/partner-tags-import?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<PartnerTagsImport>) => {
        this.importListSubject.next(result);
      });
  }

  public downloadImportFile(importId: string): void {
    this.document.location.href = `/rest/crm/partner-tags-import/${importId}/downloadFile`;
  }

}
